import { Link } from 'react-router-dom';
import styles from './styles.module.scss';
import Button from './Button';
import Slider from './Slider';
import Modal from './Modal';
import { useState } from 'react';
import ReactGA from "react-ga4";
// Ensure dataLayer exists on the global window object

ReactGA.initialize("G-HYJDMRTYFP");
ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  
const GamePaneHorror = (props) => {
const [modal,setModal] = useState(null);
const [sliderIndex,setSliderIndex] = useState(1);
    let difficultyStars = [];
    for(let i = 0; i < props.gameData.difficulty ; i++){
        difficultyStars.push(<div className={`${styles.gamePaneDifficultyStar}`}></div>);
    }

      function download(fileUrl, fileName) {
    var a = document.createElement("a");
    a.href = fileUrl;
    a.setAttribute("download", fileName);
    a.click();
  }
 


  const downloadGame = (e) => {
    console.log(props.gameData.download);
    download(`/downloadable/${props.gameData.download}.ZIP`,`${props.gameData.download}.ZIP`);
    
    

      ReactGA.event(`Download ${props.gameData.download}`, {
        'event_category': 'ZIP',
        'event_label': `/downloadable/${props.gameData.download}.ZIP`
      });
    
   
  }

  const playGame = (e) => {

    
   
      ReactGA.event(`Play ${props.gameData.name}`, {
        'event_category': 'PLAY',
        'event_label': `${props.gameData.name}`
      });
    
   
  }
  const switchDesc = (sw) => {
    const desc = document.querySelectorAll('.desc');

    desc.forEach((e,i)=>{
      e.textContent = props.gameData.slideDescriptions[sw];
    });
 
  }
  const setSliderIdx = (idx) =>{
    setSliderIndex(idx);
  }
  const openModalDesc = (idx) => {
    let data = <Slider currentIndex={sliderIndex} switch={switchDesc} set={setSliderIdx} gameData={props.gameData}></Slider>;
    
    setModal(<div className={`${styles.sliderDesc}`}>{data}
    <div className={`desc ${styles.gamePaneDescription}`}>{props.gameData.slideDescriptions[sliderIndex - 1]}</div>
    </div>);
    
  }

  const openModal = (e) => {
  let data = '';
  switch(props.gameData.id){
    case 1:
       data = <div className={styles.newsChanges} > <h1 className='white'>
          Community DLC Part 1 Added!
       </h1>
       <h2 className='white'>
        New Stuff
        </h2>
        <ul className='white'>
          <li className="li-pf">
            Playable Tung Tung Tung Sahur
            </li>
            <li className="li-pf">
              Playable Anthro
              </li>
              <li className="li-pf">
                New NPCs and Gamemodes!
                </li>
              <li className="li-pf">
                XXX Update!
                </li>
                <li className="li-pf">
                Restrooms generation update!
                </li>
          </ul>
        <hr/> 

        <h1 className='white'>
          DLC 3 Added!
       </h1>
       <h2 className='white'>
        New Stuff
        </h2>
        <ul className='white'>
          <li className="li-pf">
            Z.C.P Institution & Quickville locations
            </li>
            <li className="li-pf">
              Lesbian Dating Simulator
              </li>
              <li className="li-pf">
                Beez mode where you play as villains
                </li>
              <li className="li-pf">
                H-Endings!
                </li>
                <li className="li-pf">
                50+ Playable characters!!!
                </li>
          </ul>
        <hr/> 

        </div>;
    break;
    case 2:
      data =  <div className={styles.newsChanges}>
   
   <ul className='white'>
     <li className="li-pf"> 
       No changes were made.
         </li>
         </ul>
         <hr/>
    </div>;
    break;
    case 1:
       data = <div className={styles.newsChanges} > 
  

        </div>;
    break;
    case 3:
        data = <div className={styles.newsChanges}>
          <h1 className='white'>
            Re|Time Demo is Out!
         </h1>
         <h2 className='white'>
           Try new battle mechanics and improved old features!
        </h2>
        
            <hr/>

              <h1 className='white'>
            Version 1.16 Halloween
         </h1>
         <h2 className='white'>
           What's new
        </h2>
        <ul className='white'>
        <li className="li-pf"> 
               Halloween Event Started!!
            </li>
            </ul>
         <h2 className='white'>
            Design Changes
        </h2>
        <ul className='white'>
            <li className="li-pf"> 
               Sonia got souls displayed at character face
            </li>
            <li className="li-pf"> 
               Tealena got wheel displayed at character face
            </li>
            <li className="li-pf"> 
               Capcake got chunks
            </li>
            <li className="li-pf"> 
               Cubus got fists displayed at character face
            </li>
            <li className="li-pf"> 
               Kucyki got glonies displayed at character face
            </li>
            </ul>
            <hr/>
            <h1 className='white'>
            Version 1.14
         </h1>
         <h2 className='white'>
            Design Changes
        </h2>
         <ul className='white'>
            <li className="li-pf"> 
                Added More atomsphere
            </li>
            <li className="li-pf"> 
                Enemies in battle have animation now
            </li>
            <li className="li-pf"> 
               Game screen is bigger now
            </li>
         </ul>
         <hr/>
        <h1 className='white'>
            Version 1.13
         </h1>
         <ul className='white'>
            <li className="li-pf"> 
                Minor Bug Fixes
            </li>
         </ul>
         <hr/>
        <h1 className='white'>
            Version 1.12
         </h1>
         <ul className='white'>
            <li className="li-pf"> 
                Minor Bug Fixes
            </li>
         </ul>
         <hr/>
        <h1 className='white'>
            Version 1.10
         </h1>
         <h2 className='white'>
            Design Changes
        </h2>
         <ul className='white'>
            <li className="li-pf"> 
                 Cubus now doesn't display MP
                            </li>
                            <li className="li-pf"> 
                         Majones Tokens got added as a game mechanic
                                        </li>
                                        <li className="li-pf"> 
                                            Majones got rebalanced
                                                           </li>
                                                        <li className="li-pf"> 
                                                            Few Kucyki's skills got balanced
                                                                           </li>
                                                                         <li className="li-pf"> 
                                                                            There's new music in the game
                                                                                           </li>
                </ul>
         <hr/>
        <h1 className='white'>
            Version 1.06
         </h1>
         <h2 className='white'>
            Bug Fixes
        </h2>
        <ul className='white'>
            <li className="li-pf"> 
                Bug revolving around game over screen
                got fixed.
             </li>
                     
                </ul>
         <hr/>
        <h1 className='white'>
            Version 1.05
         </h1>
         <h2 className='white'>
            Design Changes
        </h2>
        <ul className='white'>
            <li className="li-pf"> 
                    Autosave option now exist in the game.
                            </li>
                            <li className="li-pf"> 
                                Some unecessary options got removed from
                                battle menu.
                                        </li>
                </ul>
                <h2 className='white'>
                    Balance Changes
                </h2>
                <ul className='white'>
                    <li className="li-pf"> 
                   Cubus's Passion skill restores 100 TP now
                    </li>
                    <li className="li-pf"> 
                        Cubus's Breaktime skill gives additional punch now.
                         </li>    
                         <li className="li-pf"> 
                            Some bosses got weakened
                             </li>   
                             <li className="li-pf"> 
                                Undertable section one enemies give better
                                loot and are easier to grind on.
                                 </li>  
                        </ul>
                        <h2 className='white'>
                            Bug Fixes
                        </h2>
                        <ul className='white'>
                            <li className="li-pf"> 
                                Major bugs got fixed
                             </li>
                                     
                                </ul>
                <hr/>
                <h1 className='white'>
                    Version 1.04
                 </h1>
               
        <ul className='white'>
            <li className="li-pf"> 
              Leordean appears now at Pizzeria
              and T-City where you can move through those 
              locations freely.
                            </li>
                            <li className="li-pf"> 
                            Obtaining ??? items and serials membership can be
                            done by special passwords.
                                              </li>
                </ul>
         <h2 className='white'>
            Balance Changes
        </h2>
            <ul className='white'>
                <li className="li-pf"> 
                    Kucyki can now dual wield
                    and receives x1.5 more EXP
                                </li>
                    </ul>
         <hr/>
        <h1 className='white'>
            Version 1.03
         </h1>
            <h2 className='white'>
                Bug Fixes
            </h2>
                <ul className='white'>
                    <li className="li-pf"> 
                        Game crashing should not longer
                        happen.
                                    </li>
                        </ul>
                          <hr/>
        <h1 className='white'>
            Version 1.02
         </h1>
         <h2 className='white'>
            Balance Changes
          </h2>
          <ul className='white'>
            <li className="li-pf"> 
            Sonia, Cubus, Gyren and Papercraft are easier now
                </li>
                <li className="li-pf"> 
                 Secret bosses have increased chance to perform
                 another move now.
                      </li>
                    
                          
                </ul>
                <h2 className='white'>
                    Design Changes
                  </h2>
                  <ul className='white'>
                    <li className="li-pf"> 
                        Required toy car battle got removed from garden's entrance
                                </li>
                      </ul>
                      <h2 className='white'>
                        Bug Fixes
                      </h2>
                      <ul className='white'>
                        <li className="li-pf"> 
                          Enemypedia got removed from the game, hopefully
                          lowering it's chance of crashing.
                                    </li>
                        </ul>
                          <hr/>
        <h1 className='white'>
            Version 1.01
         </h1>
         <h2 className='white'>
            Balance Changes
          </h2>
          <ul className='white'>
            <li className="li-pf"> 
              Gyren reacts now only in case
              of running
                </li>
                <li className="li-pf"> 
                    Lanet's Lightning damage
                    area skill deals proper damage now
                      </li>
                      <li className="li-pf"> 
                        Sonia's Devolution lasts shorter and is weaker now.
                          </li>
                          <li className="li-pf"> 
                           Goatiel is weaker now.
                              </li>
                              <li className="li-pf"> 
                                Pizzeria Bosses and TTF's are stronger now.
                                   </li>
                                   <li className="li-pf"> 
                                    Divided fate chapter got less enemies staying in the way.
                                       </li>
                                       <li className="li-pf"> 
                                     Those skills have cooldown now:
                                     - Rising Phoenix
                                     - Carousell Spin
                                     - Chunksaw 
                                           </li>
                </ul>
                </div>;
    break;
    case 4:
        data =  <div className={styles.newsChanges}>
       
          <h1 className='white'>
              Snapshot 0.123456
           </h1>
           <h2 className='white'>
              New Features
            </h2>
            <ul className='white'>
              <li className="li-pf"> 
                World of Vampirim expands it's initial content, be ready to face it heroes!!
                  </li>
                  </ul>
                  <hr/>
                 <h1 className='white'>
              Version 1.01
           </h1>
           <h2 className='white'>
              Balance Changes
            </h2>
            <ul className='white'>
              <li className="li-pf"> 
                Weapons drop more frequent
                  </li>
                  </ul>
                  <hr/>
             </div>;
    break;
    case 5:
        data =  <div className={styles.newsChanges}>
   
   <ul className='white'>
     <li className="li-pf"> 
       No changes were made.
         </li>
         </ul>
         <hr/>
    </div>;
    break;
    case 6:
      data =  <div className={styles.newsChanges}>
            
 <ul className='white'>
   <li className="li-pf"> 
     No changes were made.
       </li>
       </ul>
       <hr/>
  </div>;
  break;
  case 7:
    data =  <div className={styles.newsChanges}>
    <h1 className='white'>
 Version 1.01
</h1>
<h2 className='white'>
 Bug Fixes
</h2>
<ul className='white'>
 <li className="li-pf"> 
   Gas Cauldrons are synchronised now.
     </li>
     </ul>
     <hr/>
     <h1 className='white'>
 Version 1.02
</h1>
<h2 className='white'>
 Bug Fixes
</h2>
<ul className='white'>
 <li className="li-pf"> 
   No more sliding from platforms.
     </li>
     </ul>
     <hr/>
</div>;
break;
    case 8:
        data =  <div className={styles.newsChanges}>

           <h1 className='white'>
 New Patch!!
</h1>
<h2 className='white'>
 Bug Fixes
</h2>
<ul className='white'>
 <li className="li-pf"> 
   Party align with your "Main" character as leader.
     </li>
      <li className="li-pf"> 
   Clown Jo Jo no longer can obtain his ending via mashing street killer's dead body.
     </li>
         <li className="li-pf"> 
   Other minor fixes.
     </li>
     
     </ul>
     <hr/>
           
          <h1 className='white'>
 New Patch!!
</h1>
<h2 className='white'>
 Bug Fixes
</h2>
<ul className='white'>
 <li className="li-pf"> 
   Apparition in the alleys doesn't insta kill anyomore.
     </li>
      <li className="li-pf"> 
   Farmland location doesn't lag anymore.
     </li>
         <li className="li-pf"> 
   Other small changes.
     </li>
     
     </ul>
     <hr/>
          <h1 className='white'>
 New Patch!!
</h1>
<h2 className='white'>
 Changes
</h2>
<ul className='white'>
  <li className="li-pf"> 
   Masks can be reclaimed from the wall after they've been placed in wrong order.
     </li>
 <li className="li-pf"> 
   Masks don't disappear after leaving theatre.
     </li>

     </ul>
     <hr/>
<h2 className='white'>
 Bug Fixes
</h2>
<ul className='white'>
 <li className="li-pf"> 
   Holy arc now drops correctly.
     </li>
      <li className="li-pf"> 
   Secret Lab closes permanently after defeating Professor.
     </li>
         <li className="li-pf"> 
   Some typography fixed here and there.
     </li>
     
     </ul>
     <hr/>

          <h1 className='white'>
 New Patch!!
</h1>
<h2 className='white'>
 Changes
</h2>
<ul className='white'>
    <li className="li-pf"> 
   New interface of timing based attack.
     </li>
  <li className="li-pf"> 
   Items cost lower prices based on their durability.
     </li>
 <li className="li-pf"> 
   Every major boss now drops unique item.
     </li>
 <li className="li-pf"> 
  Srub-I can be found in the sour location now.
     </li>
      <li className="li-pf"> 
  Sleeping bags failed cardflip, deal a lot of damage instead of killing you.
     </li>
           <li className="li-pf"> 
Notes and evidence progress is stored at home.
     </li>
             <li className="li-pf"> 
Srudlaty's gang members have their use at home.
     </li>
     </ul>
     <hr/>
<h2 className='white'>
 Bug Fixes
</h2>
<ul className='white'>
 <li className="li-pf"> 
   Srudlaty's craft ability doesn't stop working when upgrading items from bottom of the list.
     </li>
      <li className="li-pf"> 
   Some other enemy and map related bugs were fixed.
     </li>
         
     </ul>
     <hr/>

    <h1 className='white'>
 New Patch!!
</h1>
<h2 className='white'>
 Changes
</h2>
<ul className='white'>
  <li className="li-pf"> 
   Damage indicators aligned with fontstyle.
     </li>
 <li className="li-pf"> 
   Some noises got reduced.
     </li>
 <li className="li-pf"> 
  Stamina recharge speed got increased but recharges slowly after fight.
     </li>
     </ul>
     <hr/>
<h2 className='white'>
 Bug Fixes
</h2>
<ul className='white'>
 <li className="li-pf"> 
   Estate Killer doesn't hold you infinitely after losing to him.
     </li>
      <li className="li-pf"> 
   Ghosts appear at graveyard at 2 o'clock.
     </li>
         <li className="li-pf"> 
   Missing loading picture added.
     </li>
      <li className="li-pf"> 
   Softlocking store got locked for good.
     </li>
     </ul>
     <hr/>
  
</div>;
    break;
        case 9:
        data =  <div className={styles.newsChanges}>
   
   <ul className='white'>
     <li className="li-pf"> 
       No changes were made.
         </li>
         </ul>
         <hr/>
    </div>;
    break;
    case 10:
        data =  <div className={styles.newsChanges}>
   <h1 className='white'>
 DEMO VERSION AVAILABLE!!!
</h1>
<h2 className='white'>
 New Content
</h2>
<ul className='white'>
 <li className="li-pf"> 
   Chapter II early version
     </li>
      <li className="li-pf"> 
   Sexualities and Gender mechanics
     </li>
         <li className="li-pf"> 
   It got way darker, beware of the crimson.
     </li>
     
     </ul>

     <h2 className='white'>
 Bug Fixes
</h2>
<ul className='white'>

  <li className="li-pf"> 
   Transition between Chapter I and Chapter II got unlocked with ALL the characters!!!
     </li>
 <li className="li-pf"> 
   Death animation gets back to normal after resurrecting ally.
     </li>
      <li className="li-pf"> 
   Scaling of damaged senses got fixed.
     </li>
         <li className="li-pf"> 
   Ashicny's defense mechanic got fixed.
     </li>
     
     </ul>


     <h2 className='white'>
 Design Changes
</h2>
<ul className='white'>
 <li className="li-pf"> 
   Equal rule pawnflip shows one card face-up.
     </li>
      <li className="li-pf"> 
   There are spots where you can restore Skill Sources for limited uses.
     </li>
         <li className="li-pf"> 
    You can switch between STORY/NORMAL mode now disabling/enabling battles.
     </li>
     
     </ul>

     <hr/>
           
    </div>;
    break;

  }
  setModal(<div className={`${styles.versionHistory}`}>{data}</div>);
  
}
const closeModal = () => {
  setModal(null);
}
    return (
        <div className={`${styles.gamePane}`}>
            
            <div className={`${styles.blackout}`}></div>
            <Link to={"/games-horror"} style={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                top:'0%',
                left:'0%'
            }}>           
            </Link>
            <div className={`${styles.gamePaneMain} ${styles.backgroundColorDark} ${props.xmas && styles['backgroundColorDark--xmas']} ${props.halloween && styles['backgroundColorDark--halloween']}`}>
                    <div className={`${styles.gamePaneIcon}`}
                        style={{
                background: `url("/pictures/icons/${props.gameData.icon}.png") center/90% no-repeat`,
                backgroundColor: `rgba(0, 0, 0, 0.7)`
            }}></div>
                    <div className={`${styles.gamePaneTitle} ${props.xmas && styles['gamePaneTitle--xmas']} ${props.halloween && styles['gamePaneTitle--halloween']}`}>{props.gameData.name}</div>
            <div className={`${styles.gamePaneMainContainer} ${props.xmas && styles['gamePaneMainContainer--xmas']} ${props.halloween && styles['gamePaneMainContainer--halloween']}`}>
                <div className={`${styles.gamePaneContainer1} ${props.xmas && styles['gamePaneContainer1--xmas']} ${props.halloween && styles['gamePaneContainer1--halloween']}`}>
                    <div className={`${styles.gamePaneBackground}`}  style={{
                background: `url("/pictures/backgrounds/${props.gameData.id == 10 ? 'ksbackground' : props.gameData.background}.png") center/100% no-repeat`
            }}>
                       <div className={`${styles.blackout}`}></div>
                         <img className={`${styles.gamePaneCharacter}`} src={`/pictures/characters/${props.gameData.character}.png`} ></img>
                         <div className={`${styles.gamePaneMainDesc} ${props.xmas && styles['gamePaneMainDesc--xmas']} ${props.halloween && styles['gamePaneMainDesc--halloween']}`}>{props.gameData.description}</div>
                    </div>
                          <div className={`${styles.gamePaneDifficulty} ${props.xmas && styles['gamePaneDifficulty--xmas']} ${props.halloween && styles['gamePaneDifficulty--halloween']}`}>
                                  <div className={`${styles.gamePaneDifficultyTitle} ${props.xmas && styles['gamePaneDifficultyTitle--xmas']} ${props.halloween && styles['gamePaneDifficultyTitle--halloween']}`}>difficulty:</div>
                                        <div className={`${styles.gamePaneDifficultyBar} ${props.xmas && styles['gamePaneDifficultyBar--xmas']} ${props.halloween && styles['gamePaneDifficultyBar--halloween']}`}>
                                             {difficultyStars}
                                        </div>
                          </div>

                          { props.gameData.id != 5 && <Button halloween={props.halloween} xmas={props.xmas} click={downloadGame} size={"large"}>Download</Button>} {(props.gameData.isBrowser || props.gameData.id == 5) && <Link to={`/playing/:${props.gameData.id}`}><Button halloween={props.halloween} xmas={props.xmas} click={playGame} size={"large"}>Play in browser</Button></Link>}

                </div>
                     <div className={`${styles.gamePaneContainer2} ${props.xmas && styles['gamePaneContainer2--xmas']} ${props.halloween && styles['gamePaneContainer2--halloween']}`}>
                <div className={`${styles.gamePaneEmpty} ${props.xmas && styles['gamePaneEmpty--xmas']} ${props.halloween && styles['gamePaneEmpty--halloween']}`}>
                    <Slider halloween={props.halloween} xmas={props.xmas} currentIndex={sliderIndex} click={openModalDesc} set={setSliderIdx} switch={switchDesc} gameData={props.gameData}></Slider>
                </div>
                <div onClick={openModalDesc} className={`desc ${styles.gamePaneDescription} ${props.xmas && styles['gamePaneDescription--xmas']} ${props.halloween && styles['gamePaneDescription--halloween']}`}><div>{props.gameData.slideDescriptions[0]}</div></div>
                <div onClick={openModal} className={`${styles.gamePaneVersion} ${props.xmas && styles['gamePaneVersion--xmas']} ${props.halloween && styles['gamePaneVersion--halloween']}`}>VERSION</div>
                        
                     </div>
                   </div>  
            </div>
            {modal != null && <Modal halloween={props.halloween} xmas={props.xmas} click={closeModal}>{modal}</Modal>}
        </div>
    );
}


export default GamePaneHorror;